/* eslint-disable prefer-const */
import { classifyEqInterval } from './equal-interval'
import { classifyJenks } from './jenks'
import { classifyQuantile } from './quantile'
import { classifyStdDeviation } from './stdDeviation'

export function defaultFormat(a: number, b: number, separator = ' - ', precicion = 2): string {
  return a.toFixed(precicion) + separator + b.toFixed(precicion)
}

type FormatFunction<T> = (a: number, b: number) => T

/**
 * Get a ranges array from a bounds array
 */
export function getRanges<T = string>(bounds: number[], format: FormatFunction<T>): T[] {
  return bounds.slice(0, -1).map((_, idx) => format(bounds[idx], bounds[idx + 1]))
}

/**
 * Get the index of a concrete value in a bounds array
 * The index ranges from "0" to "bounds.length - 2" (= nbClass - 1)
 * returns -1 if val not in bounds
 * @param {array} bounds
 * @param {number} val
 */
export const classIdx = (bounds, val) => {
  if (val < bounds[0]) {
    return -1
  }
  for (let i = 1; i < bounds.length; i++) {
    if (val <= bounds[i]) {
      return i - 1
    }
  }
  return -1
}

/**
 * Returns the corresponding class for a value. The value comes from the
 * provided classes-array. If the value is out of bounds oob is returned.
 * @param {array} bounds
 * @param {number} val
 * @param {array} classes
 * @param {*} oob
 */
export const getClass = (bounds, val, classes, oob?) => {
  const idx = classIdx(bounds, val)
  return typeof classes[idx] !== 'undefined' ? classes[idx] : oob
}

/**
 * Wrap up all classification algorithms in one function.
 * @param {('eqInterval'|'jenks'|'quantile'|'stdDev')} algorithm
 * @param {array} serie
 * @param {number} nbClass
 */
export const classify = (algorithm, serie, nbClass) => {
  switch (algorithm) {
    case 'eqInterval':
      return classifyEqInterval(serie, nbClass)
    case 'jenks':
      return classifyJenks(serie, nbClass)
    case 'quantile':
      return classifyQuantile(serie, nbClass)
    case 'stdDev':
      return classifyStdDeviation(serie, nbClass)
    default:
      throw Error('Can not classify series. Algorithm "' + algorithm + '" not known')
  }
}

export { classifyEqInterval, classifyJenks, classifyQuantile, classifyStdDeviation }
